import Image from 'next/image';
import { cn } from '@/core/utils/cn';

interface AvatarProps {
  src?: string | null;
  name?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeStyles = {
  sm: 'w-6 h-6 text-[10px]',
  md: 'w-8 h-8 text-[12px]',
  lg: 'w-10 h-10 text-[14px]',
  xl: 'w-14 h-14 text-[18px]',
};

function getInitials(name?: string) {
  if (!name) return '?';
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
}

export function Avatar({ src, name, size = 'md', className }: AvatarProps) {
  return (
    <div className={cn(
      'relative rounded-full bg-hms-surface flex items-center justify-center font-semibold text-hms-textSub overflow-hidden flex-shrink-0',
      sizeStyles[size],
      className
    )}>
      {src ? (
        <Image src={src} alt={name || 'Avatar'} fill sizes="56px" className="object-cover" unoptimized />
      ) : (
        getInitials(name)
      )}
    </div>
  );
}
